/// <reference path="../../../../vendor/angular/angular.js" />
/// <reference path="../../../../vendor/angular-ui/ui-bootstrap-custom-tpls.js" />
/// <reference path="../../services/searchService.js" />

'use strict';

angular.module('systemOwnerControllers', [
    'ngAnimate',
    'ui.bootstrap',
    'mgcrea.ngStrap',
    'services.search']);